import { Slider, Typography } from '@mui/material'
import css from './SliderQuestion.module.css'


const getSliderColor = (value, max) => {
  const percentage = (value / max) * 100
  if (percentage > 80) return 'primary'
  if (percentage > 50) return 'secondary'
  if (percentage <= 20) return 'success'
  return 'error'
}

const SliderQuestion = ({ question, optional, options, value, onChange }) => {
  // Parse options to get min and max values
  const numericOptions = options ? options.map(opt => parseInt(opt, 10)) : [0, 10]
  const min = Math.min(...numericOptions)
  const max = Math.max(...numericOptions)

  // Use default value if not set - start at highest value
  const currentValue = value !== null && value !== undefined ? value : max

  return (
    <div className={css.question}>
      <Typography className={css.title} variant="h5">
        {question} {optional && <span className={css.optional}>(opcional)</span>}
      </Typography>
      <div className={css.slider}>
        <Slider
          value={currentValue}
          marks
          min={min}
          max={max}
          valueLabelDisplay="auto"
          color={getSliderColor(currentValue, max)}
          onChange={(e, value)=> onChange(value)}
        />
      </div>
    </div>
  )
}

export default SliderQuestion